module.exports = __webpack_public_path__ + "static/img/weather19.4100a73b.png";